import React, { Component } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import moment from 'moment/moment'
import _ from 'lodash'

import { Button, Card, Col, Drawer, Form, notification, Row, Tooltip, Checkbox } from 'antd/lib/index'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'

import { connect } from 'react-redux'
import LatestFollowUp from '../../../../components/_utils/latestFollowup'

import styles from './styles.less'
import rightAuth from '../../../../components/_utils/userRights'

import lodash from 'lodash'

import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'

let userCheckBox = {}
let counsellingData = {}

@Form.create()
class DrawerForm extends Component {
    handleSubmit = e => {
        const { form, handleSubmit, singleDueInvoice, dueInvoiceId } = this.props

        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)

                this.setState({ loading: true })
                values._id = singleDueInvoice._id
                values.dueInvoiceId = dueInvoiceId


                let x = await Request.updateDueInvoiceStatus(values)


                if (!x.error) {

                    notification.success({
                        message: x.msg

                    })
                    if (handleSubmit) {
                        handleSubmit()
                    }
                    form.resetFields()


                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }

                this.setState({ loading: false })


            }
        })
    }

    constructor(props) {
        super(props)
        this.state = {
            showBranchCommission: false,
            branchCommissionValue: 0,
            loading: false
        }
    }

    async componentDidMount() {


        const { singleDueInvoice } = this.props

        let branchId = singleDueInvoice && singleDueInvoice.studentBranchId._id

        let { doc: branchData } = await Request.getBranch(branchId)
        this.setState({
            branchCommissionValue: branchData && branchData.commission
        })


    }

    render() {

        const { singleDueInvoice, form } = this.props
        const { branchCommissionValue } = this.state

        const commentBox = {
            fields: [

                {
                    label: 'Select Status',
                    key: 'status',
                    type: 'select',
                    customProps: {
                        style: {
                            width: '60%'
                        }
                    },
                    options: ['Invoice Pending for Payment at University', 'Invoice Paid by the University', 'Invoice not cleared by University – Bad Debts'],
                    onChange: v => {
                        form.setFieldsValue({ status: v })

                        if (v === 'Invoice Paid by the University') {


                            if (singleDueInvoice && singleDueInvoice.dueInvoices && singleDueInvoice.dueInvoices.invoiceNo === 1 || singleDueInvoice.dueInvoices.invoiceNo === 2) {

                                this.setState({ showBranchCommission: true, changeStatusValue: false }, () => {
                                    form.setFieldsValue({ branchCommission: branchCommissionValue })
                                })
                            } else {

                                this.setState({ changeStatusValue: false })
                            }
                        } else if (v === 'Invoice not cleared by University – Bad Debts') {
                            this.setState({ changeStatusValue: true, showBranchCommission: false })
                        } else {

                            this.setState({ changeStatusValue: false, showBranchCommission: false })
                        }
                    }
                },


                {
                    label: 'Comment',
                    key: 'comment',
                    type: 'textArea',
                    required: this.state.changeStatusValue ? true : false,
                    rows: 5,
                    customProps: {
                        style: {
                            width: '55%'
                        }
                    },
                    hidden: this.state.changeStatusValue ? false : true
                },
                {
                    label: 'Branch Commission ', key: 'branchCommission', type: 'number',
                    required: this.state.showBranchCommission ? true : false,
                    hidden: this.state.showBranchCommission ? false : true,
                    rightComp: <span style={{ paddingLeft: '5px' }}>%</span>
                }

            ]
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: {
                    span: 8,
                    md: { span: 4 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                    md: { span: 12 }
                }
            }
        }
        const {
            form: { getFieldDecorator }
        } = this.props
        return (


            <Form onSubmit={this.handleSubmit} hideRequiredMark>


                <Row>

                    <Col span={24}>

                        <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={commentBox}
                            getFieldDecorator={getFieldDecorator}
                            formItemLayout={formItemLayout}

                        />
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={this.state.loading}>
                                UPDATE
                            </Button>
                        </Form.Item>

                    </Col>

                </Row>


            </Form>
        )


    }
}

class dueInvoices extends Component {


    state = {
        count: 0,
        studentId: null,
        channelPartnerList: [],
        allBranches: [],
        deskColor: null,
        leadSourceList: ['University', 'Channel Partner'],
        invoiceStatusList: ['Invoice Processed', 'Invoice Pending for Payment at University', 'Invoice Paid by the University', 'Invoice not cleared by University – Bad Debts'],
        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        userCheckBox: {},
    }

    loadChannelPartners = async () => {
        let { data: channelPartnerList } = await Request.getSimplePartners({
            results: 10000
        })
        this.setState({ channelPartnerList })
    }


    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights()
        this.setState({ claimDeskRights: userRights.ClaimDesk })
    }

    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showSMS: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeSMS = () => {
        this.setState({ showSMS: false })
    }
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked === true ? item : false);
        })

        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showWhatsAppSms: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeWhatsSMS = () => {
        this.setState({ showWhatsAppSms: false })
    }
    closeEmail = () => {
        this.setState({ showEmail: false })
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showEmail: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] === undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }
            params.atLevel = ['Claim Desk']

            let data = await Request.dueInvoicesList({
                ...params
            })

            delete data.error
            delete data.type

            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({ count: data.data.length, allBranches: data.allBranches, userCheckBox: userCheckBox })
            resolve(data)
        })
    }

    showDrawer = () => {
        this.setState({
            visible: true
        })
    }


    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.loadChannelPartners()
        this.loadUserRights()
    }

    async componentDidMount() {

    }

    render() {
        const {
            allBranches = [],
            deskColor,
            invoiceStatusList,
            channelPartnerList,
            leadSourceList,
            dueInvoiceId,
            singleDueInvoice,
            claimDeskRights
        } = this.state


        const columns = [
            {
                title: 'ID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                width: 80,
                fixed: true,
                searchTextName: 'id',
                filterRegex: true
            },
            {
                title: 'Student Name (Mobile/WAP/E mail)',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                width: 200,
                fixed: true,
                searchTextName: 'studentName',
                filterRegex: true,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <Tooltip title="Click To Edit Details">
                                <a className={styles.btn} target={'_blank'}
                                    href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                >{text}</a>
                            </Tooltip>
                            <div>{record.mobile}</div>

                            <div>
                                {record.watsupp && record.watsupp.length === 10 ?
                                    <Tooltip title="Share on Whatsapp">
                                        <a target={'_blank'}
                                            style={{ textDecoration: 'underline' }}
                                            href={`http://api.whatsapp.com/send?phone=91${record.watsupp}&text=&source=&data=`}>{record.watsupp}</a>
                                    </Tooltip>
                                    : record.watsupp}

                            </div>
                            <div>{record.emailId}</div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'DOB ',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                searchDateName: 'dateOfBirth',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format('DD-MMM-YYYY')
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Passport No',
                key: 'passportNo',
                searchTextName: 'passportNo',
                filterRegex: true,
                width: 100,
                dataIndex: 'visaDesk.passportNo'
            },
            {
                title: 'Course/University',
                key: 'selectedCourse',
                width: 250,
                dataIndex: 'visaDesk.selectedCourse',
                searchTextName: 'course/University',
                filterRegex: true,
                render: (text, record) => {
                    return (<div>
                        <div>{text ? text.courseName : ''}</div>
                        <div>{text ? text.universityInstitutionName : ''}</div>
                    </div>)
                }
            },
            {
                title: 'Branch',
                key: 'branchId',
                filters: allBranches,
                width: 80,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Term',
                width: 100,
                key: 'invoiceNo',
                dataIndex: 'dueInvoices.invoiceNo',
                searchTextName: 'invoiceNo',
                filterRegex: true
            },
            {
                title: 'Invoice Ref No.',
                width: 100,
                key: 'invoiceRefNo',
                dataIndex: 'dueInvoices.invoiceRefNo',
                searchTextName: 'invoice Ref No',
                filterRegex: true
            },
            {
                title: 'Invoice Dated',
                key: 'invoiceDate',
                width: 100,
                searchDateName: 'invoiceDate',
                dataIndex: 'dueInvoices.invoiceDate',
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Tution Fee',
                key: 'tutionFee',
                dataIndex: 'dueInvoices.tutionFee',
                width: 80,
                render: (text, record) => {
                    return <div>{text && `${record.dueInvoices.currency} ${text}`}</div>
                }
            },
            {
                title: 'Commission',
                key: 'commission',
                dataIndex: 'dueInvoices.commission',
                width: 90,
                render: (text, record) => {
                    return <div>{text && `${text}%`}</div>
                }
            },
            {
                title: 'Invoice Amount',
                key: 'invoiceAmount',
                dataIndex: 'dueInvoices.commissionAmount',
                width: 100,
                render: (text, record) => {
                    return <div>{text && `${record.dueInvoices.currency} ${text}`}</div>
                }
            },
            {
                title: 'Invoice Due Date',
                key: 'dueDate',
                width: 100,
                searchDateName: 'dueDate',
                dataIndex: 'dueInvoices.dueDate',
                render: (text, record) => {
                    return (
                        <div>{text ? moment(text).format('DD-MMM-YYYY') : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Invoice Status',
                key: 'invoiceStatus',
                dataIndex: 'dueInvoices.status',
                filters: invoiceStatusList && invoiceStatusList.map(x => ({ value: x, text: x })),
                width: 150,
                render: (text, record) => {
                    if (text === 'Invoice not cleared by University – Bad Debts') {

                        return (
                            <div>
                                <div>{text}</div>
                                <small style={{ color: '#ffa500' }}>
                                    {record && record.dueInvoices && record.dueInvoices.comment}
                                </small>
                            </div>

                        )
                    } else {

                        return (
                            <div>{text}
                            </div>
                        )
                    }

                }
            },
            {
                title: 'Follow Up Note',
                key: 'followUp',
                width: 200,
                dataIndex: 'followUp',
                render: (text, record) => {
                    return <LatestFollowUp info={text} />
                }
            }, {
                title: 'Actions',
                key: 'opertaions22',
                render: (text, record) => {
                    let condition = record && record.dueInvoices
                    return (
                        <div>
                            <React.Fragment>
                                <div className={styles.btnWrapper}>
                                    <span className={styles.userSelectCheckbox}>
                                        <Checkbox
                                            checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                                            onChange={y => {
                                                this.selectUser(y, record._id)
                                            }}>
                                        </Checkbox>
                                    </span>
                                </div>
                            </React.Fragment>
                            {claimDeskRights && !claimDeskRights.viewByBranch &&
                                condition && (condition.status === 'Invoice Pending for Payment at University' || condition.status === 'Invoice Processed' || condition.status === 'Invoice not cleared by University – Bad Debts') &&
                                <Button size={'small'} style={{
                                    marginLeft: '3px',
                                    marginBottom: '3px',
                                    fontSize: '11px',
                                    paddingLeft: '13px',
                                    paddingRight: '13px',
                                    backgroundColor: '#1a73e8', color: 'white',
                                    border: '1px solid #1a73e8',
                                    borderRadius: '2px'

                                }} onClick={() => {
                                    this.setState({
                                        dueInvoiceId: record && record.dueInvoices._id,
                                        inquiryId: record && record._id,
                                        singleDueInvoice: record
                                    }, () => {
                                        this.showDrawer()
                                    })

                                }}>Change Status</Button>}

                            {rightAuth.checkRights('ClaimDesk.view') && !rightAuth.checkRights('ClaimDesk.viewByBranch') ?
                                <React.Fragment>
                                    {condition && condition.uploadInvoice && condition.uploadInvoice.length > 0 &&
                                        <Button size={'small'} style={{
                                            marginLeft: '3px',
                                            fontSize: '11px',
                                            padding: '5px',
                                            border: '1px solid #1a73e8',
                                            color: 'black',
                                            borderRadius: '2px'
                                        }} onClick={() => {

                                            window.open(
                                                `${MEDIA_URL}/${condition.uploadInvoice[0].url}`,
                                                '_blank'
                                            )

                                        }}>Download Invoice</Button>}
                                </React.Fragment> : ''}
                        </div>
                    )

                }
            }]

        if (claimDeskRights && !claimDeskRights.viewByBranch) {

            let dataItem = {
                title: 'Invoicee',
                key: 'leadSource',
                dataIndex: 'leadSource',
                width: 180,
                filters: leadSourceList && leadSourceList.map(x => ({ value: x, text: x })),
                render: (text, record) => {
                    let found
                    if (record.visaDesk.channelPartnerId !== '') {
                        found = _.find(channelPartnerList, (item) => {
                            return item._id === record.visaDesk.channelPartnerId
                        })
                    }
                    return (<div>
                        <div>{text}</div>
                        <small style={{ color: '#ffa500' }}>{found ? found.channelPartnerName : ''}</small>
                    </div>)
                }
            }

            let editColumn = {
                title: 'Action',
                key: 'opertaions',
                width: 60,
                fixed: true,
                render: (text, record) => {
                    return (<div>{
                        record && record.dueInvoices && record.dueInvoices.status !== 'Invoice Paid by the University' &&
                        <div>
                            <Tooltip title="Click To Edit Details">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    size={'small'}
                                    href={`/desk/generateInvoice/update?id=${record._id}&dueInvoiceId=${record && record.dueInvoices && record.dueInvoices._id}`}
                                    icon="edit"
                                />
                            </Tooltip>

                        </div>
                    }</div>)


                }
            }

            columns.splice(6, 0, dataItem)
            columns.splice(0, 0, editColumn)

        }

        return (
            <PageHeaderWrapper deskColor={deskColor} title={`Invoice List : ${this.state.count} `}>
                {this.state.showWhatsAppSms ? (
                    <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
                ) : null}

                {this.state.showSMS ? (
                    <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
                ) : null}

                {this.state.showEmail ? (
                    <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
                ) : null}
                <Card style={{ marginBottom: 10 }}>
                    <div className={styles.filterBlock}>
                        <div className={styles.myBtnGroup}>
                            <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                                <Button
                                    className={styles.btn}
                                    type="primary"
                                    onClick={() => this.showEmail()}>Send E-mail
                                </Button>
                                <Button
                                    type="primary"
                                    className={styles.btn}
                                    onClick={() => this.showSMS()}>Send SMS
                                </Button>
                                <Button
                                    type="primary"
                                    className={styles.btn}
                                    onClick={() => this.showWhatsAppSms()}>Whatsapp
                                </Button>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.selectAllUserFxn()}>Select Visible
                                </Button>
                                <Button
                                    className={styles.btn}
                                    onClick={() => this.unselectAllUserFxn()}>Unselect Visible
                                </Button>
                            </div>
                        </div>
                    </div>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        rowKey={(item, x) => {
                            return x
                        }}
                        columns={columns}
                        ref={this.table}
                        id={'claimDesk'}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: claimDeskRights && !claimDeskRights.viewByBranch ? 2200 : 1960 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
                <Drawer
                    title=""
                    forceRender={true}
                    placement="right"
                    closable={true}
                    onClose={() => {

                        this.setState({
                            visible: false
                        })
                    }}
                    visible={this.state.visible}
                    width={600}>
                    <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20, textAlign: 'center' }}>
                        {this.state.visible && <DrawerForm
                            singleDueInvoice={singleDueInvoice && singleDueInvoice}
                            dueInvoiceId={dueInvoiceId}

                            handleSubmit={() => {

                                this.setState({ visible: false })
                                this.table.current.reload()

                            }} />}
                    </div>


                </Drawer>

            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    currentUser: global.currentUser,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(dueInvoices)
